const PromocodeListTabs = [
    {
        title: 'Код',
        isSorting: true,
        isFilter: false,
        sorting: {
            sortingTabs: [{
                sortingName: 'code',
                sortingAsc: 'code',
                sortingDesc: '-code',
                sortingAscTitle: 'Сортировка "От А до Я"',
                sortingDescTitle: 'Сортировка "От Я до А"'
            }],
        }
    },
    {
        title: 'Срок действия',
        isSorting: true,
        isFilter: false,
        sorting: {
            sortingTabs: [
                {
                    sortingName: 'start_dt',
                    sortingAsc: 'start_dt',
                    sortingDesc: '-start_dt',
                    sortingAscTitle: 'По дате начала (возрастание)',
                    sortingDescTitle: 'По дате начала (убывание)'
                },
                {
                    sortingName: 'end_dt',
                    sortingAsc: 'end_dt',
                    sortingDesc: '-end_dt',
                    sortingAscTitle: 'По дате окончания (возрастание)',
                    sortingDescTitle: 'По дате окончания (убывание)'
                },
            ],
        }
    },
    {
        title: 'Период',
        isSorting: false,
        isFilter: true,
        filters: {
            filtersName: 'period',
            filtersTabs: [
                {
                    filterTabTitle: 'Все',
                    filterTabRequest: ''
                },
                {
                    filterTabTitle: 'День',
                    filterTabRequest: 'period=DAY'
                },
                {
                    filterTabTitle: 'Неделя',
                    filterTabRequest: 'period=WEEK'
                },
                {
                    filterTabTitle: 'Месяц',
                    filterTabRequest: 'period=MONTH'
                },
                {
                    filterTabTitle: 'Бессрочная',
                    filterTabRequest: 'period=LIFETIME'
                },
            ]
        }
    },
    {
        title: 'Сумма',
        isSorting: false,
        isFilter: false,
    },
    {
        title: 'Тип орг.',
        isSorting: false,
        isFilter: true,
        filters: {
            filtersName: 'user_organization_type',
            filtersTabs: [
                {
                    filterTabTitle: 'Все',
                    filterTabRequest: ''
                },
                {
                    filterTabTitle: 'ООО',
                    filterTabRequest: 'user_organization_type=LLC'
                },
                {
                    filterTabTitle: 'АО',
                    filterTabRequest: 'user_organization_type=JSC'
                },
                {
                    filterTabTitle: 'ИП',
                    filterTabRequest: 'user_organization_type=INDIVIDUAL_ENTREPRENEUR'
                },
                {
                    filterTabTitle: 'Физлицо',
                    filterTabRequest: 'user_organization_type=INDIVIDUAL'
                },
                {
                    filterTabTitle: 'Самозанятый',
                    filterTabRequest: 'user_organization_type=SELF_EMPLOYED'
                },
            ]
        }
    },
    {
        title: 'Триал',
        isSorting: false,
        isFilter: true,
        filters: {
            filtersName: 'has_trial_period',
            filtersTabs: [
                {
                    filterTabTitle: 'Все',
                    filterTabRequest: ''
                },
                {
                    filterTabTitle: 'С триалом',
                    filterTabRequest: 'has_trial_period=true'
                },
                {
                    filterTabTitle: 'Без триала',
                    filterTabRequest: 'has_trial_period=false'
                },
            ]
        }
    },
    {
        title: 'Статус',
        isSorting: false,
        isFilter: true,
        filters: {
            filtersName: 'is_valid',
            filtersTabs: [
                {
                    filterTabTitle: 'Все',
                    filterTabRequest: ''
                },
                {
                    filterTabTitle: 'Активные',
                    filterTabRequest: 'is_valid=true'
                },
                {
                    filterTabTitle: 'Неактивные',
                    filterTabRequest: 'is_valid=false'
                },
            ]
        }
    },
    {
        title: '',
        isSorting: false,
        isFilter: false,
    }
]

export default PromocodeListTabs
